var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteArea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#303141"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7002 11.3027C4.96055 11.5631 5.38266 11.5631 5.64301 11.3027L7.99998 8.94576L10.357 11.3028C10.6173 11.5631 11.0395 11.5631 11.2998 11.3028C11.5602 11.0424 11.5602 10.6203 11.2998 10.36L8.94279 8.00295L11.2999 5.64588C11.5602 5.38554 11.5602 4.96342 11.2999 4.70308C11.0395 4.44273 10.6174 4.44272 10.3571 4.70307L7.99998 7.06014L5.64296 4.70311C5.38261 4.44276 4.9605 4.44276 4.70015 4.70311C4.4398 4.96346 4.4398 5.38557 4.70014 5.64592L7.05718 8.00295L4.7002 10.3599C4.43985 10.6203 4.43985 11.0424 4.7002 11.3027Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteArea);
export default __webpack_public_path__ + "static/media/delete_area.5b4ef20fff3fe6f0b4d56a4ee5432030.svg";
export { ForwardRef as ReactComponent };